import { BaseModel } from './base.model'
import { Lesson } from './lesson.model'
import { StartExamConfig } from './start-exam-config.model'
import { StaticScreen } from './static-screen.model'
import { SystemScreen } from './system-screen.model'
import { Video } from './video.model'
import { Speech } from './speech.model'
import { Exam } from "./exams/exam.model"

export class ProgramSection extends BaseModel<ProgramSection> {
  static DEFAULT_ATTRIBUTES = {}

  _destroy: boolean
  content: Lesson|StartExamConfig|StaticScreen|SystemScreen|Video|Speech|Exam
  contentId: number
  id: number
  position: number
  type: string
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/program-section.model.ts